export const MENU_CATEGORY_PICKER_ID = 'menu-category-picker';

export type CategorySelection = {
    categoryId: string | null | undefined;
    subCategoryId: string | null | undefined;
};

export const isSameCategorySelection = (a: CategorySelection, b: CategorySelection) =>
    a.categoryId === b.categoryId && a.subCategoryId === b.subCategoryId;

/** True when el or an ancestor sticks/fixes (picker may be relative inside sticky chrome). */
export const isStickyOrFixed = (el: Element | null) => {
    for (let node = el as HTMLElement | null; node; node = node.parentElement) {
        const position = getComputedStyle(node).position;
        if (position === 'sticky' || position === 'fixed') return true;
    }
    return false;
};

/** Prefers #navbar-wrapper; falls back for customized navbars without that id. */
export const getStickyNavbarOffset = () => {
    const byId = document.getElementById('navbar-wrapper');
    if (byId) return byId.getBoundingClientRect().height;

    const hit = document.elementFromPoint?.(Math.floor(window.innerWidth / 2), 1) ?? null;
    for (let node = hit as HTMLElement | null; node; node = node.parentElement) {
        if (isStickyOrFixed(node)) return node.getBoundingClientRect().height;
    }
    return 0;
};

/**
 * Sticky picker → feed start (picker stays in view).
 * Non-sticky picker → picker top so the chips stay on screen after filter.
 */
export const getCategoryFilterScrollY = (feedEl: HTMLElement, pickerEl: HTMLElement | null) => {
    const target = pickerEl && !isStickyOrFixed(pickerEl) ? pickerEl : feedEl;
    return Math.max(0, target.getBoundingClientRect().top + window.scrollY - getStickyNavbarOffset() - 16);
};

/** Selection change only reshapes which rows exist — remasure would flash the full list. */
export const shouldSkipRemasureForCategoryFilter = (selectionChanged: boolean) => selectionChanged;

/** Scroll only while a filter is active and the page is already below the target (not on clear / when above). */
export const shouldScrollToCategoryFilter = (
    selection: CategorySelection,
    currentScrollY: number,
    targetScrollY: number,
) => Boolean(selection.categoryId || selection.subCategoryId) && currentScrollY > targetScrollY;
